import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import styles from "@/styles/NextLink.module.scss";
import ArrowRight from "./Icons/ArrowRight";
import Link from "next/link";

/**
 * Interface defining the props for the NextLink component
 * @interface NextLinkProps
 * @property {string} href - The URL that the link points to
 * @property {string} title - The content to be rendered inside the link
 * @property {string} [className] - Optional CSS class name for styling
 * @property {'_blank' | '_self' | '_parent' | '_top'} [target] - Optional target attribute for the link
 * @property {string} [rel] - Optional rel attribute for the link
 * @property {Function} [onClick] - Optional click event handler
 */
interface NextLinkProps {
  href?: string;
  title: string;
  className?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  rel?: string;
  as?: string;
  type?: "submit" | "reset" | "button";
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  icon?: React.ReactElement<SVGElement>;
  isLeft? : boolean;
}
const NextLink: React.FC<NextLinkProps> = ({
  href,
  title,
  className,
  target,
  rel,
  onClick,
  as = "link",
  type,
  icon,
  isLeft,
  ...rest
}) => {
  const buttonProps: DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> = {
    className: className || "",
    onClick,
    type,
    ...rest
  };

  return (
    <>
      {as === "button" ? (
        <button {...buttonProps} className={`${styles.link} ${className || ''} ${isLeft ? styles.left : ''}`}>
          <span>{title}</span>
          <span className={styles.arrow}>
            <ArrowRight />
          </span>
          <span className={styles.hoverCircle}></span>
        </button>
      ) : (
        <Link
          href={href || '/'}
          className={`${styles.link} ${className || ''} ${isLeft ? styles.left : ''}`}
          target={target}
          rel={rel}
          onClick={onClick}
          {...rest}
        >
          <span>{title}</span>
          <span className={styles.arrow}>
              { icon ? icon : <ArrowRight />}
          </span>
          <span className={styles.hoverCircle}></span>
        </Link>
      )}
    </>
  );
};

export default NextLink;
